import { render, staticRenderFns } from "./CollegeRegistration.vue?vue&type=template&id=7520c704&"
import script from "./CollegeRegistration.vue?vue&type=script&lang=js&"
export * from "./CollegeRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports